import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-instagram.svg";
import * as styles from "./Icon.module.scss";

type InstagramProps = React.SVGProps<SVGSVGElement>;

export const Instagram = ({ className, ...props }: InstagramProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
